export function useQueryParams(search: string) {
    return new URLSearchParams(search);
}
